import React from "react";
import Seo from "../components/Seo";
import FotoLeadForm from "../components/fotografia/FotoLeadForm";
import WhatsAppCta from "../components/fotografia/WhatsAppCta";
import { ESTUDIO } from "../data/estudio";
import { PAGES, breadcrumbJsonLd } from "../seo/config";

const crumbs = [
  { name: "Inicio", path: "/" },
  { name: "Contacto", path: "/contacto" },
];

const ContactoPage = () => (
  <>
    <Seo
      title={PAGES.contacto.title}
      description={PAGES.contacto.description}
      keywords={PAGES.contacto.keywords}
      path={PAGES.contacto.path}
      jsonLd={[breadcrumbJsonLd(crumbs)]}
    />

    <section className="bg-sand-50 pb-24 pt-28 md:pt-32">
      <div className="container-page grid gap-12 lg:grid-cols-2">
        <div>
          <h1 className="font-display text-display-md font-bold text-navy-900">Contacto</h1>
          <p className="section-copy mt-5">
            {ESTUDIO.horario.dias}, {ESTUDIO.horario.desde} a {ESTUDIO.horario.hasta}. Eventos de fin de
            semana a convenir.
          </p>
          <ul className="mt-8 space-y-3 text-navy-800">
            <li>
              <a href={`tel:+${ESTUDIO.whatsapp}`} className="font-semibold hover:text-navy-600">
                {ESTUDIO.telefonoDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${ESTUDIO.email}`} className="hover:text-navy-600">
                {ESTUDIO.email}
              </a>
            </li>
          </ul>
          <WhatsAppCta
            message="Hola Omega, quiero cotizar fotografía."
            location="contacto"
            variant="dark"
            className="mt-8"
          >
            WhatsApp
          </WhatsAppCta>
        </div>
        <div className="rounded-3xl border border-navy-100 bg-white p-6 shadow-card sm:p-8">
          <FotoLeadForm />
        </div>
      </div>
    </section>
  </>
);

export default ContactoPage;
